import PageTemplate from "../../components/ui/common/template/PageTemplate";
import MemberListTemplate from "../../components/ui/members/MemberListTemplate";
import ProfessionalImage from "./../../resources/images/professional.jpg";
const Profe1ssionalsPage = () => {
  // 근거: 전문가 추가-rev1.docx (2026-10). 관세정책은 없어진 Advisory Group에서 옮겨 왔고, 탭 안은 직급순.
  // 이름만 있고 hover 약력도 없는 6명은 정보를 받을 때까지 주석 처리(2026-10-30). 사진만 없는 사람은 그대로 둔다. 데이터는 membercontext.js에 남아 있다.
  const groups = [
    {
      category: "관세정책",
      members: ["woonki21", "y2kykim"],
    },
    {
      category: "수출입통관",
      members: [
        "ezpass",
        // "hd11234",
        "son0077",
        "buj",
        "hd11234",
        "lgman",
        "yoojung",
        "pass911",
        "k1234",
        "xanhy",
        "jeonsujin",
        // "jina1012",
        // "woon4545",
        // "donghee7747",
      ],
    },
    { category: "환급", members: ["son0077", "meenss", "lily93", "choiminjeong"] },
    {
      category: "요건/검역",
      members: ["tnt-2000", "pass911", "josep62", "sunggun"],
      // members: ["tnt-2000", "pass911", "josep62", "jhpark0113"],
    },
    {
      category: "과세가격",
      members: ["son0077", "jskim", "hwanginae", "ohhyemi"], // "leeseungeun", "choiyeongmo"
    },
    {
      category: "품목분류",
      members: ["ccam7413", "pass911", "jskim"], //, "jina1012"
    },
    {
      category: "특송",
      members: ["hd11234", "suyun"], // "parkbaeyong"
    },
    { category: "FTA", members: ["cupark", "gilho", "jskim", "ohhyemi"] }, // "leeseungeun"
    {
      category: "AEO",
      members: ["gilho", "kht3073"], // "leeseungwon", "chosangwon"
    },
    {
      category: "기업심사",
      members: ["son0077", "ccam7413", "gilho", "hwanginae"], // "leeseungeun", "choiyeongmo"
    },
    {
      category: "행정쟁송",
      members: ["y2kykim", "ccam7413", "solgae8"],
    },
    { category: "IT", members: ["cupark", "kodaeung"] }, // "leejongho"
  ];
  return (
    <PageTemplate
      title="분야별 전문가"
      phrase="준비된 관세 Specialist와 함께하세요."
      large
      image={ProfessionalImage}
    >
      <MemberListTemplate groups={groups} />
    </PageTemplate>
  );
};
export default Profe1ssionalsPage;
